/**
 * @file
 * A JavaScript file containing the main menu functionality (small/large screen)
 *
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth


// (function (Drupal) { // UNCOMMENT IF DRUPAL.
//
//   Drupal.behaviors.mainMenu = {
//     attach: function (context) {

(function () { // REMOVE IF DRUPAL.

  'use strict';

  var topImage = document.querySelector('article.node .field--field-top-image');
  var windowWidth = checkWidth();
  moveQuotes();
  if(checkWidth() <= 1000 ){
    moveTopImage(true);
  }

  window.addEventListener("resize", resizeThrottler, false);

  var resizeTimeout;
  function resizeThrottler() {
    // ignore resize events as long as an actualResizeHandler execution is in the queue
    if ( !resizeTimeout ) {
      resizeTimeout = setTimeout(function() {
        resizeTimeout = null;
        if(checkWidth() <= 960 ){
          moveTopImage(true);
        } else {
          moveTopImage(false);
        }


        // The actualResizeHandler will execute at a rate of 15fps
      }, 66);
    }
  }

  function moveTopImage(mobile) {
    if(topImage && mobile) {
      topImage.parentNode.appendChild(topImage);
    } else if(topImage) {
      topImage.parentNode.insertBefore(topImage, topImage.parentNode.firstChild);
    }
  }

  function moveQuotes(){
    console.log('test');
    let quotes = document.querySelectorAll('.pagetype--node-highlighted_faculty .node .field--field-new-body .field__item--paragraph--blockquote.field__item');
    for(let quote of quotes) {
      topImage.append(quote);
      quote.classList.remove('field__item--last');
      quote.querySelector('.paragraph--shift-right').classList.remove('paragraph--shift-right');
      document.querySelector('.pagetype--node-highlighted_faculty .node .field--field-new-body .field__item:last-of-type').classList.add('field__item--last');
    }
  }



  function checkWidth(){
    return document.documentElement.clientWidth;
  }

  // Use context instead of document IF DRUPAL.


})(); // REMOVE IF DRUPAL.

// })(Drupal); // UNCOMMENT IF DRUPAL.
